<template>
  <div :class="$style['footer']" class="flex-grow-0"><slot /></div>
</template>

<style module lang="scss">
.footer {
  margin-top: 30px;

  :global(.btn) {
    min-width: 100px;
  }
}
</style>
